import {
  UNLOCK_ACCOUNT_ADMIN_USER,
  UNLOCK_ACCOUNT_ADMIN_USER_SUCCESS,
  UNLOCK_ACCOUNT_ADMIN_USER_ERROR,
  UNLOCK_TOKEN_ADMIN_USER,
  UNLOCK_TOKEN_ADMIN_USER_SUCCESS,
  UNLOCK_TOKEN_ADMIN_USER_ERROR
} from "./actionTypes";


export const unlockAccountAdminUser = (user) => {
  return {
    type: UNLOCK_ACCOUNT_ADMIN_USER,
    payload: user,
  }
}

export const unlockAccountAdminUserSuccess = user => {
  return {
    type: UNLOCK_ACCOUNT_ADMIN_USER_SUCCESS,
    payload: user,
  }
}

export const unlockAccountAdminUserError = error => {
  return {
    type: UNLOCK_ACCOUNT_ADMIN_USER_ERROR,
    payload: error,
  }
}

export const unlockTokenAdminUser = (user, history) => {
  return {
    type: UNLOCK_TOKEN_ADMIN_USER,
    payload: { user, history },
  }
}

export const unlockTokenAdminUserSuccess = user => {
  return {
    type: UNLOCK_TOKEN_ADMIN_USER_SUCCESS,
    payload: user,
  }
}

export const unlockTokenAdminUserError = error => {
  return {
    type: UNLOCK_TOKEN_ADMIN_USER_ERROR,
    payload: error,
  }
}